<!-- 参赛人员 -->
<template>
  <div class="personal-wrap" @mouseleave="isAvatarIntroShow = false">
    <p class="name">
      参会人员
    </p>
    <div class="box">
      <div class="list">
        <div class="item" :style="{ background: '#B41D23' }">
          A
        </div>
        <div class="item" :style="{ background: '#F9C33C' }">
          T
        </div>
        <div class="item" :style="{ background: '#2F3367' }">
          A
        </div>
        <div class="item" :style="{ background: '#B41D23' }">
          C
        </div>
        <div class="item" :style="{ background: '#F9C33C' }">
          A
        </div>
      </div>
      <img src="../../assets/img/icons/icon-personal-more.png" class="more-personal" @click="isAvatarIntroShow = !isAvatarIntroShow">
      <div class="all">
        6人参会
      </div>
      <Transition name="slide-fade">
        <div class="avatar-intro-list" v-show="isAvatarIntroShow">
          <div class="avatar-intro-item">
            <span class="avatar">A</span>
            <span class="txt">一参会人名字</span>
          </div>
          <div class="avatar-intro-item">
            <span class="avatar">C</span>
            <span class="txt">二参会人名字</span>
          </div>
          <div class="avatar-intro-item">
            <span class="avatar">X</span>
            <span class="txt">三参会人名字</span>
          </div>
          <div class="avatar-intro-item">
            <span class="avatar">X</span>
            <span class="txt">四参会人名字</span>
          </div>
          <div class="avatar-intro-item">
            <span class="avatar">X</span>
            <span class="txt">五参会人名字</span>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';


const isAvatarIntroShow = ref(false);

</script>

<style lang="less" scoped>
/*
  进入和离开动画可以使用不同
  持续时间和速度曲线。
*/
.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.personal-wrap {
  width: 30.20833vw;
  margin: 0 auto;

  .name {
    font-size: 0.9375vw;
    line-height: 1.30208vw;
    font-weight: bold;
    color: #2F3367;
    margin-bottom: 0.41666vw;
  }

  .box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .list {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-right: 0.41666vw;

      .item {
        width: 2.08333vw;
        font-size: 0.9375vw;
        line-height: 2.08333vw;
        text-align: center;
        color: #fff;
        background: #B41D23;
        border: 0.10416vw solid #fff;
        border-radius: 50%;
        margin-left: -0.625vw;

        &:first-child {
          border: none;
          margin-left: 0;
        }
      }
    }

    .more-personal {
      display: block;
      width: 0.625vw;
      margin-right: 2.08333vw;
    }

    .all {
      font-size: 0.83333vw;
      line-height: 1;
      color: #171A41;
    }
  }
}

@media screen and (max-width: 750px) {

  .personal-wrap {
    width: 82.93333vw;

    .name {
      font-size: 3.73333vw;
      line-height: 5.33333vw;
      margin-bottom: 1.6vw;
    }

    .box {

      .list {
        margin-right: 2.13333vw;

        .item {
          width: 7.46666vw;
          font-size: 3.2vw;
          line-height: 7.46666vw;
          border: 0.4vw solid #fff;
          margin-left: -1.6vw;
        }
      }

      .more-personal {
        width: 4.26666vw;
        margin-right: 8.53333vw;
      }

      .all {
        font-size: 3.73333vw;
      }
    }
  }

}

.avatar-intro-list {
  position: absolute;
  top: calc(100% + 0.41666vw);
  left: 0;
  width: 8.85416vw;
  box-sizing: border-box;
  background: #fff;
  border-radius: 0.83333vw;
  padding: 0.83333vw 1.25vw;
  box-shadow: 0px 4px 16px 0px rgba(149,157,165,0.12);
  z-index: 90;
}

.avatar-intro-list .avatar-intro-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0.625vw;
}

.avatar-intro-list .avatar-intro-item:last-child {
  margin-bottom: 0;
}

.avatar-intro-list .avatar-intro-item .avatar {
  display: block;
  width: 1.25vw;
  font-size: 0.52083vw;
  line-height: 1.25vw;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  background: #B41D23;
  margin-right: 0.625vw;
  flex-shrink: 0;
}

.avatar-intro-list .avatar-intro-item .txt {
  display: block;
  font-size: 0.9375vw;
  line-height: 1;
  color: #2F3367;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

@media screen and (max-width: 750px) {
  
  .avatar-intro-list {
    top: calc(100% + 0.8vw);
    width: 41.2vw;
    height: 65.33333vw;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 6vw 5.33333vw;
  }

  .avatar-intro-list .avatar-intro-item {
    margin-bottom: 6.66666vw;
  }

  .avatar-intro-list .avatar-intro-item .avatar {
    width: 5.33333vw;
    font-size: 2.4vw;
    line-height: 5.33333vw;
    margin-right: 2.13333vw;
  }

  .avatar-intro-list .avatar-intro-item .txt {
    font-size: 4.8vw;
  }
  
}
</style>